import styled, { keyframes } from 'styled-components';

export const MENU_ITEM_HEIGHT = 38;

export const Container = styled.div`
  position: relative;
`;

const shortcutsListTransition = keyframes`
  from {
    opacity: 0;
    visibility: hidden;
  }

  to {
    opacity: 1;
    visibility: visible;
  }
`;

export const ShortcutsListContainer = styled.div`
  width: 190px;
  filter: drop-shadow(0px 3px 6px #0000003d);
  border-radius: 2px;
  position: fixed;
  z-index: 99999999;
  background: #fff;
  animation: ${shortcutsListTransition} 0.3s ease;

  button {
    display: flex;
    align-items: center;
    gap: 4px;
    height: ${MENU_ITEM_HEIGHT}px;
    padding: 0 6px;
    cursor: pointer;
    border: none;
    border-radius: 0;
    background: #fff;
    width: 100%;

    &:hover {
      background: var(--grey-100);
    }

    p {
      flex: 1;
      line-height: normal;
      min-width: 0;
    }
  }

  button + button {
    border-top: 1px solid var(--grey-200);
  }

  &::after {
    content: '';
    position: absolute;
    left: 0%;
    margin-left: -16px;
    border-width: 8px;
    border-style: solid;
    border-color: transparent #fff transparent transparent;
  }

  &.placement-top::after {
    top: 0;
  }

  &.placement-bottom::after {
    bottom: 0;
  }

  &:has(button:first-child:hover)::after {
    border-color: transparent var(--grey-100) transparent transparent;
  }
`;
